import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Button from "@mui/joy/Button";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

const DeletePopup = ({ open, setOpen, label, handleDelete }) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)} >
      <ModalDialog
        variant="outlined"
        role="alertdialog"
        sx={{
          borderRadius: "16px",
          p: 3,
          width: 350,
          textAlign: "center",
            maxHeight: "80vh",
    overflowY: "auto",
        }}
      >
        <WarningRoundedIcon
          sx={{ fontSize: 50, color: "#d32f2f", mb: 1 }}
        />

        <DialogTitle sx={{ fontWeight: "bold", fontSize: "18px" }}>
          Confirm Delete
        </DialogTitle>

        <DialogContent sx={{ fontSize: "14px", color: "text.secondary",  textAlign: "left",px:"0" }}>
          {label}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
          <Button
            variant="solid"
            color="danger"
            onClick={handleDelete}
          >
          Delete
          </Button>

          <Button
            variant="outlined"
            color="neutral"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default DeletePopup;